import React, { useCallback, useEffect, useState } from "react";
import InvalidatedSessionsDialog from "./InvalidatedSessionDialog";
import { INVALIDATED_SESSIONS_EVENT } from "../../common/api/hooks/useAxiosPrivate";

/**
 * Listens for login responses that signed out other devices and shows
 * {@link InvalidatedSessionsDialog} (auto-close after 3s by default).
 */
export default function InvalidatedSessionsHost() {
    const [open, setOpen] = useState(false);
    const [sessions, setSessions] = useState([]);

    useEffect(() => {
        const onInvalidated = (event) => {
            const list = event.detail?.sessions;
            if (!Array.isArray(list) || list.length === 0) {
                return;
            }
            setSessions(list);
            setOpen(true);
        };

        window.addEventListener(INVALIDATED_SESSIONS_EVENT, onInvalidated);
        return () => {
            window.removeEventListener(INVALIDATED_SESSIONS_EVENT, onInvalidated);
        };
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
        setSessions([]);
    }, []);

    return (
        <InvalidatedSessionsDialog
            open={open}
            sessions={sessions}
            onClose={handleClose}
        />
    );
}
